import React from 'react'

import AddRepForm from '../../modules/Rep/components/AddRepForm'
export default function AddRepPage() {
  return (
    <AddRepForm/>  )
}
